import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import styled, { css } from 'styled-components';

import { getHubspotContact } from 'features/hubspot/actions';
import { isHubspotFormSubmitted } from 'features/hubspot/utils';

import { ThemeProvider } from 'styled-components';
import { withTheme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

import ContentTypography from 'components/ContentTypography';

import { HubspotFormWrapper } from './elements';

const FormProgressWrapper = styled.div`
  text-align: center;
`;

const FormProgress = styled(CircularProgress)`
  ${props =>
    props.overrideColor &&
    css`
      svg {
        color: #fff;
      }
    `}
`;

const SmallTypography = styled(Typography)`
  font-size: 11px;
  margin-top: 15px;
  text-align: center;
  a {
    text-decoration: none;
    color: ${props =>
      props.theme.palette.type === 'dark' ? '#fff' : '#1b1b1b'};
  }
`;

class HubspotForm extends React.PureComponent {
  makeHubspotForm(formId, formUniqueId) {
    // makes hubspot form on div with #id defined by target value
    window.hbspt.forms.create({
      css: '',
      portalId: '2418554',
      formId: formId,
      target: `#form-${formUniqueId}`,
      formInstanceId: `instance-${formUniqueId}`
    });
  }

  loadHubspotScript(formId, formUniqueId) {
    let script = document.createElement(`script`);
    script.defer = true;
    script.onload = () => {
      this.makeHubspotForm(formId, formUniqueId);
    };
    script.src = `//js.hsforms.net/forms/v2.js`;
    document.head.appendChild(script);
  }

  loadChiliPiperScript() {
    let script = document.createElement(`script`);
    script.defer = true;
    script.src = `//js.chilipiper.com/marketing.js`;
    document.head.appendChild(script);
  }

  componentWillMount() {
    this.setState({
      formUniqueId: shortid.generate(),
      isFormSubmitted: false
    });
  }

  componentDidMount() {
    const {
      formId,
      hideOnSubmit,
      getHubspotContact,
      useChiliPiperConcierge
    } = this.props;

    if (hideOnSubmit) {
      getHubspotContact();
    }

    if (useChiliPiperConcierge) {
      if (!window.ChiliPiper) {
        this.loadChiliPiperScript();
      }
      var cpTenantDomain = 'synthego';
      var cpRouterName = 'contact-sales';
      var lead = {};
      window.addEventListener('message', function(event) {
        if (event.data.type === 'hsFormCallback') {
          if (event.data.eventName === 'onFormSubmit') {
            for (var key in event.data.data) {
              if (Array.isArray(event.data.data[key].value)) {
                event.data.data[key].value = event.data.data[key].value
                  .toString()
                  .replaceAll(',', ';');
              }
              lead[event.data.data[key].name] = event.data.data[key].value;
            }
            if (Object.keys(lead).length <= 1) {
              lead = event.data.data;
            }
          } else if (event.data.eventName === 'onFormSubmitted') {
            window.ChiliPiper.submit(cpTenantDomain, cpRouterName, {
              map: true,
              lead: lead
            });
          }
        }
      });
    }

    if (!window.hbspt) {
      this.loadHubspotScript(formId, this.state.formUniqueId);
    } else {
      this.makeHubspotForm(formId, this.state.formUniqueId);
    }
  }

  render() {
    const {
      formId,
      buttonColor,
      buttonAlign,
      size,
      inline,
      hideOnSubmit,
      submittedMessage,
      hubspotContact,
      hideRecaptcha
    } = this.props;

    return (
      <ThemeProvider theme={this.props.theme}>
        {hideOnSubmit && isHubspotFormSubmitted(formId, hubspotContact) ? (
          <ContentTypography
            variant="body2"
            dangerouslySetInnerHTML={{
              __html: submittedMessage || 'Form already submitted.'
            }}
            align="center"
          />
        ) : (
          <>
            <HubspotFormWrapper
              id={`form-${this.state.formUniqueId}`}
              buttonColor={buttonColor}
              buttonAlign={buttonAlign}
              size={size}
              inline={inline}
              hideRecaptcha={hideRecaptcha}
              theme={this.props.theme}
            >
              <FormProgressWrapper>
                <FormProgress
                  size={24}
                  overrideColor={
                    this.props.theme.palette.type === 'dark' ||
                    buttonColor === 'white'
                  }
                />
              </FormProgressWrapper>
            </HubspotFormWrapper>
            {hideRecaptcha && (
              <SmallTypography variant="caption">
                This site is protected by reCAPTCHA and the Google{' '}
                <a href="https://policies.google.com/privacy">Privacy Policy</a>{' '}
                and{' '}
                <a href="https://policies.google.com/terms">Terms of Service</a>{' '}
                apply.
              </SmallTypography>
            )}
          </>
        )}
      </ThemeProvider>
    );
  }
}

HubspotForm.propTypes = {
  formId: PropTypes.string.isRequired,
  buttonColor: PropTypes.string,
  size: PropTypes.string,
  inline: PropTypes.bool,
  hideOnSubmit: PropTypes.bool,
  submittedMessage: PropTypes.string,
  hubspotContact: PropTypes.object
};

export default connect(
  state => ({
    hubspotContact: state.hubspot.hubspotContact
  }),
  {
    getHubspotContact
  }
)(withTheme()(HubspotForm));
